import React from 'react'

export default function useSession(initialValue:any, key:string) {

    let v
    try {
        const stored = sessionStorage.getItem(key)
        v = stored ? JSON.parse(stored) : initialValue
    } catch (e) {
        v = initialValue
    }
    const [state, setState] = React.useState(v)

    React.useEffect(() => {
        sessionStorage.setItem(key, JSON.stringify(state))
    }, [state, key])

    return [state, setState]
}
